import type { IconSvgObject } from './types';

const PayByCheckIcon: IconSvgObject = [
  ["path", { d: "M6.5 11H4C2.89543 11 2 11.8954 2 13V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V13C22 11.8954 21.1046 11 20 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 18H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 14H13L21 6L18 3L10 11V14Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PayByCheckIcon;
